import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { DownloadOutlined } from '@ant-design/icons';

import { DownloadFolderModal } from 'common/components';
import RibbonButton from 'common/components/button/RibbonButton';

import gridSelector from 'common/components/grid-view/controllers/selectors';
import * as folderSelectors from 'pages/folders/controllers/selectors';

import Messages from 'i18n/messages/home';

const DownloadFolder = () => {
  const [downloadModalVisible, setDownloadModalVisible] = useState(false);

  const selectedItems = useSelector(
    gridSelector.makeSelectDetailCurrentITemsSelection()
  );

  const selectedFolder =
    selectedItems.length === 1 &&
    selectedItems[0].type.toLowerCase() === 'folder'
      ? selectedItems[0]
      : null;

  const { folderBreadcrumb } = useSelector(
    folderSelectors.selectFolderListByLevel()
  );

  const onClick = () => {
    setDownloadModalVisible(true);
  };

  const getFolderId = () => {
    //* no select anything
    if (!selectedItems.length) {
      return currentFolder?.id === 'home' ? null : currentFolder?.id;
    }

    if (selectedFolder)
      //* select folder
      return selectedFolder.id;

    //* select another item type, prevent opening
    if (selectedItems.length > 0 && !selectedFolder) return null;
  };

  const closeDownloadModalVisible = () => {
    setDownloadModalVisible(false);
  };

  const currentFolder = folderBreadcrumb[folderBreadcrumb?.length - 1];
  const folderId = getFolderId();

  return (
    <>
      <RibbonButton
        icon={<DownloadOutlined />}
        label={Messages.downloadFolder}
        onClick={onClick}
        disabled={!folderId}
      />
      <DownloadFolderModal
        visible={downloadModalVisible}
        folderId={folderId}
        closeModal={closeDownloadModalVisible}
      />
    </>
  );
};

export default DownloadFolder;
